/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Out_Reason_For_Product_PackagingInputs */

const vi_pll_out_reason_for_product_packaging = /** @type {(inputs: Pll_Out_Reason_For_Product_PackagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng gói từ thành phẩm`)
};

/**

* @param {Pll_Out_Reason_For_Product_PackagingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_out_reason_for_product_packaging = /** @type {((inputs?: Pll_Out_Reason_For_Product_PackagingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Out_Reason_For_Product_PackagingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_out_reason_for_product_packaging(inputs)
});